const validatedTagCache: {
  browser: Record<string, boolean>;
  server: Record<string, boolean>;
} = {
  browser: {},
  server: {}
};

/**
 * isValidHTMLElement
 *
 * On the server, we use the same validation/RegEx as react-dom/src/server/ReactPartialRenderer.js#L139
 * https://github.com/facebook/react/blob/73fa26a88b68bca77fb234fc405649d0f33a3815/packages/react-dom/src/server/ReactPartialRenderer.js#L139
 *
 * On the client, we use a check similar to react-dom/src/client/ReactDOMFiberComponent.js#L389
 * https://github.com/facebook/react/blob/73fa26a88b68bca77fb234fc405649d0f33a3815/packages/react-dom/src/client/ReactDOMFiberComponent.js#L389
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLUnknownElement
 *
 * In both cases, we keep a cache of validated tags (not shared).
 */
export function isValidHTMLElement(tag: string): boolean {
  if (!Object.prototype.hasOwnProperty.call(validatedTagCache.browser, tag)) {
    validatedTagCache.browser[tag] =
      Object.prototype.toString.call(document.createElement(tag)) !== '[object HTMLUnknownElement]';
  }
  return validatedTagCache.browser[tag];
}
